import { GenericService } from 'services/genericService';
import { getOrderStatus } from 'utils/api/queries/microApi';
import { Observable } from 'rxjs';
import { OrderStatuses } from 'utils/api/models/orderTracking/orderStatus';
import { getOrders } from 'utils/api/queries/omantelApi';
import { getPurchaseDeviceOrder } from 'utils/api/queries/eshopWcsApi';
import { getPurchaseDeviceHistory, getOrderTracking } from 'utils/api/queries/eshopApi';
import { PurchaseDeviceHistoryResponse } from 'utils/api/models/eshop/purchaseDeviceHistory';
import { TrackingKeys, IGetOrderTracking } from 'utils/api/models/eshop/tracking';
import { map } from 'rxjs/operators';
import moment from 'moment';

interface ITracking {
	status: TrackingKeys;
	statusTime: string;
	sequence: string;
}

export interface IGetOrderTrackingResponse {
	trackingNumber: string;
	orderItems: string[];
	tracking: ITracking[];
	trackingUrl: string;
}

export class OrderTrackingService extends GenericService {
	public static getOrderStatus(accountNo: string, crNo: string, msisdn: string): Observable<OrderStatuses> {
		return getOrderStatus(accountNo, crNo, msisdn).call();
	}
	public static getPurchaseDeviceHistory(
		pageNumber: number,
		pageSize: number
	): Observable<PurchaseDeviceHistoryResponse> {
		return getPurchaseDeviceHistory(pageNumber, pageSize).call();
	}
	public static getPurchaseDeviceOrder(orderNumber: string) {
		return getPurchaseDeviceOrder(orderNumber).call();
	}
	public static getOrders(dateFrom?: string, dateTo?: string) {
		return getOrders({ dateFrom, dateTo }).call();
	}

	public static getOrderTracking({ orderId }: { orderId: string }): Observable<IGetOrderTrackingResponse[] | null> {
		return getOrderTracking({ orderId })
			.call()
			.pipe(
				map<{ orderTracking: IGetOrderTracking }, IGetOrderTrackingResponse[]>(({ orderTracking }) => {
					const response: IGetOrderTrackingResponse[] | null = [];
					for (const key in orderTracking) {
						if (orderTracking[key] && key !== 'GIFTCARD' && key !== 'DIGITAL_PRODUCT') {
							const { orderItems, trackingNumber, tracking, trackingUrl } = orderTracking[key];
							response.push({
								orderItems,
								trackingNumber,
								trackingUrl,
								tracking: (() => {
									const _tracking: ITracking[] = [];
									for (const trackingKey in tracking) {
										if (trackingKey) {
											const { statusTime, sequence } = tracking[trackingKey as TrackingKeys];
											const time = moment(statusTime, 'DD.MM.YYYY');
											_tracking.push({
												status: trackingKey as TrackingKeys,
												statusTime: time.isValid() ? time.format('DD MMM YYYY') : '',
												sequence,
											});
										}
									}
									_tracking.sort((a, b) => {
										if (Number(a.sequence) < Number(b.sequence)) return -1;
										return 1;
									});
									return _tracking;
								})(),
							});
						}
					}
					return response;
				})
			);
	}
}
